import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'utilities/app-insights';
import { useSelector } from 'react-redux';

/**
 * Calls the fetch notification periodically
 */
export const useTrackPageViews = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);
  
  useEffect(() => {
    trackPageView(location.pathname, loggedInUser, assignedAccountNumber);
  }, [location.pathname]);
};